<template>
  <div>
    <div class="custom-card-header">
      <span>
        {{ this.$t('NutritionalMonitoring') }}
      </span>
    </div>
    <div v-if="!loaded" class="loadingFalse">
      <div class="preloader">
        <span class="preloader-inner">
          <span class="preloader-inner-circle"></span>
        </span>
      </div>
    </div>
    <div v-else style="margin: 7px">
      <DxDataGrid
        :data-source="data"
        :show-borders="false"
        :show-column-lines="false"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-column-headers="true"
        :show-colon="false"
        :remote-operations="true"
        :hover-state-enabled="false"
        :show-row-lines="false"
        :row-alternation-enabled="false"
        :no-data-text="$t('noDataTextSummary')"
        class="custom-grid custom-grid-NutritionalFollowingTable"
        @toolbar-preparing="onToolbarPreparing($event)"
      >
        <DxScrolling mode="standard" />
        <DxStateStoring
          :enabled="false"
          type="localStorage"
          storage-key="nutritionalFollowingTable"
        />
        <DxPaging :page-size="5" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20]"
          :show-info="true"
          info-text="{2} items"
          :visible="true"
        />
        <DxSearchPanel
          :visible="true"
          :width="300"
          :placeholder="$t('search')"
        />
        <DxExport :enabled="false" />
        <DxColumn
          data-field="parcel"
          :caption="$t('agronomySample.summary.parcel')"
          alignment="left"
          :allow-header-filtering="false"
        />

        <DxColumn
          data-field="cultive"
          :caption="$t('agronomySample.cultive')"
          alignment="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="variety"
          :caption="$t('variety')"
          alignment="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          :caption="$t('lastReceipt')"
          alignment="left"
          data-field="sampling_date"
          data-type="date"
          :format="$helpers.getDateFormat(company)"
          :allow-header-filtering="false"
        />

        <!-- <DxColumn
          data-field="status"
          :caption="$t('status')"
          alignment="left"
          :width="150"
          :allow-header-filtering="false"
          cell-template="cellTemplateStatus"
        /> -->

        <DxColumn
          :buttons="editButtons"
          :fixed="true"
          fixed-position="right"
          type="buttons"
          width="70"
        />

        <template #cellTemplateStatus="{ data }">
          <div class="greenStatus" style="text-align: center">
            {{ data.value }}
          </div>
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
} from 'devextreme-vue/data-grid';
import { mapState, mapActions } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import { downloadReportMixin } from '@/mixins/downloadReportMixin';

export default {
  name: 'NutritionalFollowingTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
  },
  mixins: [downloadReportMixin],
  data() {
    return {
      loaded: false,
      data: [],
      editButtons: [
        {
          icon: iconVisibility,
          onClick: this.viewNutritionalMonitoring,
          cssClass: 'grid-button-icon',
        },
        // {
        //   icon: 'download',
        //   onClick: this.download,
        // },
      ],
    };
  },
  computed: {
    ...mapState('contact', ['company']),
  },
  async beforeMount() {
    try {
      this.loaded = false;
      const dataUnformatted = await this.getNutritionalMonitoring();
      this.data =
        dataUnformatted?.data?.sort((a, b) =>
          a.parcel > b.parcel ? 1 : -1
        ) || [];
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }
  },
  methods: {
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });
    },
    async download(e) {
      const { sample_id, study_id, code } = e.row.data;
      const downloaded = await this.downloadDualReport({ sample_id, study_id, code });
      if (!downloaded) {
        this.$notifyDX(
          { message: this.$t('sampleHasNoReport'), width: 450 },
          'info',
          2000
        );
      }
    },
    viewNutritionalMonitoring(e) {
      this.setReportSampleId(e.row.data.sample_id);
      this.setReportSampleCode(e.row.data.code);
      this.setParcelId(e.row.data.parcel_id);
      this.setParcelStr(e.row.data.parcel);
      this.setId(e.row.data.id);
      this.setLastRouteGeotoolbox(false);

      this.$f7router.navigate(
        { name: 'NutritionalMonitoringPage' },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    ...mapActions('nutritionalFollowing', [
      'getNutritionalMonitoring',
    ]),
    ...mapActions('nutritionalMonitoring', [
      'setParcelId',
      'setId',
      'setLastRouteGeotoolbox',
    ]),
    ...mapActions('samples', ['setReportSampleCode']),
    ...mapActions('registerFarm', ['setParcelStr', 'setParcel']),
  },
};
</script>
<style>
.custom-grid-NutritionalFollowingTable .dx-toolbar-before {
  width: 100%;
  padding-right: 0px !important;
  display: grid;
  grid-template-columns: 120px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-NutritionalFollowingTable
  .dx-toolbar-before
  :nth-child(1) {
  grid-row: 1;
  grid-column: 1;
}
</style>
